<section class="analyticsPage">
  <header class="pageHeader">
    <div><span class="eyebrow">B2C</span><h1>Аналитика сайта</h1>
      <p>Поведение посетителей, корзины, VIN и конверсия в обращения и заказы.</p></div>
    <div class="filters">
      <label>С <input type="date" [(ngModel)]="fromDate"></label>
      <label>По <input type="date" [(ngModel)]="toDate"></label>
      <button mat-flat-button color="primary" (click)="load()" [disabled]="loading">
        <mat-icon>refresh</mat-icon> Обновить
      </button>
    </div>
  </header>
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div class="error" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="summary as s">
    <div class="metrics">
      <article><span>Посетители</span><strong>{{ s.visitors }}</strong><small>только вовлечённые</small></article>
      <article><span>Сессии</span><strong>{{ s.sessions }}</strong><small>{{ s.rawSessions - s.sessions }} неактивных отфильтровано</small></article>
      <article><span>Активное время</span><strong>{{ duration(s.activeSeconds) }}</strong></article>
      <article><span>Просмотры</span><strong>{{ s.pageViews }}</strong></article>
      <article><span>Поиски</span><strong>{{ s.searches }}</strong><small>{{ s.emptySearches }} пустых</small></article>
      <article><span>VIN-запросы</span><strong>{{ s.vinLookups }}</strong><small>{{ s.uniqueVins }} уникальных</small></article>
      <article><span>Корзина</span><strong>{{ s.cartChanges }}</strong><small>{{ conversion(s.cartChanges) }}</small></article>
      <article><span>Checkout</span><strong>{{ s.checkouts }}</strong><small>{{ conversion(s.checkouts) }}</small></article>
      <article><span>Заказы</span><strong>{{ s.orders }}</strong><small>{{ conversion(s.orders) }}</small></article>
      <article><span>Сумма заказов</span><strong>{{ s.orderValue | number:'1.0-2' }} ₴</strong></article>
      <article><span>Контакты</span><strong>{{ s.contacts }}</strong><small>{{ conversion(s.contacts) }}</small></article>
      <article><span>Регистрации</span><strong>{{ s.registrations }}</strong><small>{{ conversion(s.registrations) }}</small></article>
    </div>

    <section class="panel trafficPanel"><h2>Источники и воронка</h2>
      <table><tr><th>Источник</th><th>Сессии</th><th>Товары</th><th>Корзина</th><th>Checkout</th><th>Заказы</th><th>Сумма</th></tr>
        <tr *ngFor="let row of s.trafficSources">
          <td><strong>{{ sourceLabel(row.source) }}</strong></td><td>{{ row.sessions }}</td>
          <td>{{ row.productSessions }}</td><td>{{ row.cartSessions }}</td><td>{{ row.checkoutSessions }}</td>
          <td>{{ row.orders }}</td><td>{{ row.orderValue | number:'1.0-2' }} ₴</td>
        </tr></table>
    </section>

    <div class="split">
      <section class="panel"><h2>Популярные страницы</h2>
        <table><tr><th>Страница</th><th>Просмотры</th><th>Время</th></tr>
          <tr *ngFor="let row of s.topPages"><td>{{ row.path }}</td><td>{{ row.views }}</td>
            <td>{{ duration(row.activeSeconds) }}</td></tr></table>
      </section>
      <section class="panel"><h2>География</h2>
        <table><tr><th>Страна / город</th><th>Посетители</th></tr>
          <tr *ngFor="let row of s.geography"><td>{{ row.country }} · {{ row.city }}</td><td>{{ row.visitors }}</td></tr></table>
      </section>
    </div>
  </ng-container>

  <mat-tab-group>
    <mat-tab label="Посетители">
      <div class="journalFilters">
        <input placeholder="ID, телефон, имя или VIN" [(ngModel)]="search" (keyup.enter)="load()">
        <input placeholder="Страна или город" [(ngModel)]="location" (keyup.enter)="load()">
        <select [(ngModel)]="registered"><option value="">Все</option><option value="true">Зарегистрированные</option><option value="false">Гости</option></select>
        <select [(ngModel)]="hasCart"><option value="">Любая корзина</option><option value="true">С корзиной</option><option value="false">Без корзины</option></select>
        <select [(ngModel)]="event"><option value="">Любое событие</option><option value="search_empty">Пустой поиск</option><option value="cart_change">Корзина</option><option value="checkout_start">Checkout</option><option value="order_created">Заказ</option><option value="phone_click">Клик телефона</option><option value="messenger_click">Мессенджер</option></select>
        <button mat-stroked-button (click)="load()">Применить</button>
      </div>
      <div class="tableWrap"><table><tr><th>Посетитель</th><th>Локация</th><th>Первый / последний визит</th><th>Корзина</th><th>VIN</th><th></th></tr>
        <tr *ngFor="let v of visitors">
          <td><strong>{{ v.accountId ? ((v.name || '') + ' ' + (v.surname || '')) : v.visitorId.slice(-12) }}</strong><small>{{ v.phone || (v.accountId ? 'Аккаунт #' + v.accountId : 'Гость') }}</small></td>
          <td>{{ v.country || 'Не определено' }} · {{ v.city || 'Не определено' }}</td>
          <td>{{ v.firstSeenAt | date:'dd.MM HH:mm' }}<br>{{ v.lastSeenAt | date:'dd.MM HH:mm' }}</td>
          <td>{{ v.cartItems }} шт. · {{ v.cartTotal | number:'1.0-2' }} ₴</td>
          <td><ng-container *ngIf="v.accountId; else noVin"><strong>{{ v.vinLookups }}</strong><small *ngIf="v.vinLookups">{{ v.uniqueVins }} уник.</small></ng-container><ng-template #noVin>—</ng-template></td>
          <td><button mat-button color="primary" (click)="openVisitor(v)">История</button></td>
        </tr></table></div>
    </mat-tab>
    <mat-tab label="Поиски">
      <div class="journalFilters">
        <select [(ngModel)]="searchResult">
          <option value="">Все запросы</option>
          <option value="true">С результатами</option>
          <option value="false">Без результатов</option>
        </select>
        <button mat-stroked-button (click)="load()">Применить</button>
      </div>
      <div class="tableWrap"><table><tr><th>Запрос</th><th>Результат</th><th>Кто искал</th><th>Последний раз</th><th></th></tr>
        <tr *ngFor="let s of searchQueries">
          <td><strong>{{ s.query }}</strong><small *ngIf="s.attempts > 1">{{ s.attempts }} раз</small></td>
          <td><span [class]="s.noResults ? 'resultNo' : 'resultOk'">{{ s.noResults ? 'Нет результатов' : 'Есть результаты' }}</span></td>
          <td>
            <ng-container *ngIf="s.accountId; else guestWho">
              <strong>{{ ((s.name || '') + ' ' + (s.surname || '')).trim() || 'Аккаунт #' + s.accountId }}</strong>
              <small>{{ s.phone || 'телефон не указан' }}</small>
            </ng-container>
            <ng-template #guestWho>
              <strong>{{ s.visitorId ? s.visitorId.slice(-12) : '—' }}</strong><small>Гость</small>
            </ng-template>
          </td>
          <td>{{ s.lastAt | date:'dd.MM HH:mm' }}</td>
          <td><button mat-button color="primary" *ngIf="s.visitorDbId" (click)="openVisitorById(s.visitorDbId)">История</button></td>
        </tr></table></div>
    </mat-tab>
    <mat-tab label="Регистрации">
      <div class="tableWrap"><table><tr><th>Регистрация</th><th>Клиент</th><th>VIN</th><th>Корзина / заказ</th></tr>
        <tr *ngFor="let r of registrations">
          <td>{{ r.createdAt | date:'dd.MM.yyyy HH:mm' }}</td>
          <td><a [routerLink]="['/client/profile', r.clientId]"><strong>{{ r.name }} {{ r.surname }}</strong></a><small>{{ r.phone }} · {{ r.email || 'email не указан' }}</small></td>
          <td>{{ r.vinLookups }} запросов<br><small>{{ r.uniqueVins }} уникальных</small></td>
          <td>{{ r.cartItems }} товаров<br><small>{{ r.hasOrders ? 'Есть B2C-заказ' : 'Заказов нет' }}</small></td>
        </tr></table></div>
    </mat-tab>
  </mat-tab-group>

  <div class="detailBackdrop" *ngIf="selectedVisitor || detailLoading" (click)="closeVisitor()">
    <aside class="detail" (click)="$event.stopPropagation()">
      <button mat-icon-button class="close" (click)="closeVisitor()"><mat-icon>close</mat-icon></button>
      <h2>История посетителя</h2>
      <mat-spinner *ngIf="detailLoading" diameter="36"></mat-spinner>
      <ng-container *ngIf="selectedVisitor as d">
        <mat-tab-group class="detailTabs">
          <mat-tab label="Сессии ({{ d.sessions?.length || 0 }})">
            <div class="detailTab">
              <div class="timeline" *ngFor="let session of d.sessions">
                <strong>{{ sourceLabel(session.trafficSource) }}</strong>
                <span>{{ session.startedAt | date:'dd.MM HH:mm:ss' }} · {{ duration(session.activeSeconds) }}</span>
                <small>{{ session.utmCampaign || session.landingPath || session.referrer || 'Прямой заход' }}</small>
                <small *ngIf="session.gclid || session.gbraid || session.wbraid">Рекламный click ID сохранён</small>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Корзина ({{ d.cart?.items?.length || 0 }})">
            <div class="detailTab">
              <ng-container *ngIf="d.cart?.items?.length; else emptyCart">
                <table class="cartTable"><tr><th>Товар</th><th>Кол-во</th><th>Цена</th><th>Сумма</th></tr>
                  <tr *ngFor="let item of d.cart.items">
                    <td>
                      <a [routerLink]="['/product', item.productId]" (click)="closeVisitor()">
                        <strong>{{ (item.brand ? item.brand + ' ' : '') + (item.article || '#' + item.productId) }}</strong>
                      </a>
                      <small>{{ item.description || 'Товар не найден в базе' }}</small>
                    </td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.price | number:'1.0-2' }} ₴</td>
                    <td>{{ item.sum | number:'1.0-2' }} ₴</td>
                  </tr></table>
                <div class="cartTotal">
                  <small>обновлена {{ d.cart.updatedAt | date:'dd.MM HH:mm' }}</small>
                  <span>Итого: <strong>{{ d.cart.total | number:'1.0-2' }} ₴</strong></span>
                </div>
              </ng-container>
              <ng-template #emptyCart><p class="cartEmpty">Корзина пуста.</p></ng-template>
            </div>
          </mat-tab>
          <mat-tab label="Страницы ({{ d.pages.length }})">
            <div class="detailTab">
              <div class="timeline" *ngFor="let page of d.pages">
                <strong>{{ page.path }}</strong><span>{{ page.firstSeenAt | date:'dd.MM HH:mm:ss' }} · {{ duration(page.activeSeconds) }}</span>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="События ({{ d.events.length }})">
            <div class="detailTab">
              <div class="timeline" *ngFor="let event of d.events">
                <strong>{{ event.type }}</strong><span>{{ event.occurredAt | date:'dd.MM HH:mm:ss' }} · {{ event.path }}</span>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="VIN ({{ d.vinLookups?.length || 0 }})">
            <div class="detailTab">
              <div class="timeline" *ngFor="let vin of d.vinLookups">
                <strong class="vinRow">
                  <span class="vinCode">{{ vin.vin || 'VIN не сохранён' }}</span>
                  <button mat-icon-button *ngIf="vin.vin" (click)="copyVin(vin.vin)" title="Скопировать VIN">
                    <mat-icon>{{ copiedVin === vin.vin ? 'check' : 'content_copy' }}</mat-icon>
                  </button>
                </strong>
                <span><span [class]="vin.success ? 'resultOk' : 'resultNo'">{{ vin.success ? 'Авто найдено' : 'Авто не найдено' }}</span> · {{ vin.createdAt | date:'dd.MM HH:mm:ss' }}</span>
              </div>
              <p class="cartEmpty" *ngIf="!d.vinLookups?.length">VIN-запросов не было.</p>
            </div>
          </mat-tab>
        </mat-tab-group>
      </ng-container>
    </aside>
  </div>
</section>
